<template>
    <div class="mt-3">
        <div>
            <label
                for="code-body"
                class="font-14 d-flex flex-column"
            >
                CSS avançado
                <small class="helper-text">O campo permite editar o CSS do site. Insira código CSS aqui para personalizar a aparência do seu site, como cores, tamanhos de fonte e posicionamento. Requer conhecimento básico de CSS.</small>
            </label>

            <div class="d-flex flex-column">
                <small>&lt;style&gt;</small>

                <textarea name="code-body" id="code-body" rows="8" v-model="css"></textarea>

                <small class="mt-0">&lt;/style&gt;</small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameAdvanced',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            css: '',
        }
    },
    watch: {
        css: {
            handler() {
                this.css.includes('<style>') ? this.css = this.css.replace('<style>', '') : null;
                this.css.includes('</style>') ? this.css = this.css.replace('</style>', '') : null;

                this.$emit('onCssInputChange', this.css)
            },
            deep: true
        }
    },
    mounted() {
        this.css = this.item.extra.css_code;
    }
}
</script>

<style scoped>
  .helper-text {
    font-size: 0.5rem;
  }  
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameAdvanced.vue